import type { BariPreNurseSpecialistMedScreeningReportDataV2 } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/v2/bariPreNurseSpecialistMedScreeningReportDataV2';
import { initialDataV1 } from '../v1/bariPreNurseSpecialistMedScreeningReportDataV1';

export const initialDataV2: BariPreNurseSpecialistMedScreeningReportDataV2 = {
    ...initialDataV1,
    depressie: null,
    longziekte_astma_of_copd: null,
};
